<template>
  <div>
    <!--预付项目，待预付和已预付 -->
    <div v-if="dataModel.presale">
      <van-col class="text-primary font-14 line-14" v-if="expect && (status === 'prepaying' || status === 'pricing')">
              <span class="color-88 font-11 line-11">
                预计总价<span>{{dataModel.amount|getMoney|getMoney1}}</span><span class="font-11">{{dataModel.amount|getMoney|getMoney2}}</span>，
              </span>
        <span class="color-55 font-14 line-14">
               预计应付
              </span>
        <span class="color-55 font-11 mr-1p">¥ </span><span>{{expectMoney|getMoney|getMoney1}}</span><span
        class="font-11">{{expectMoney|getMoney|getMoney2}}</span>
        <!--              <span class=" font-11">00</span>-->
      </van-col>
      <!-- 待支付 -->
      <van-col class="text-primary font-14 line-14" v-if=" status === 'topay'">
              <span class="color-88 font-11 line-11">
                总价¥ <span>{{dataModel.amount|getMoney|getMoney1}}</span><span class="font-11">{{dataModel.amount|getMoney|getMoney2}}</span>，
              </span>
        <span class="color-88 font-11 line-11" v-if="status !== 'topay'">
                已预付¥ <span>{{dataModel.presaleAmount|getMoney|getMoney1}}</span><span class="font-11">{{dataModel.presaleAmount|getMoney|getMoney2}}</span>，
              </span>
        <span class="color-55 font-14 line-14">
                {{status==='pricing'?'待付':'应付'}}
              </span>
        <span class="color-55 font-11 mr-1p">¥</span>
        <span>{{dataModel.unpaidAmount|getMoney|getMoney1}}</span><span class="font-11">{{dataModel.unpaidAmount|getMoney|getMoney2}}</span>
      </van-col>

    </div>

    <!-- 待支付 -->
    <van-col class="text-primary font-14 line-14" v-else-if="status === 'topay'">
      <span class="color-88 font-11 line-11" v-if="dataModel.amount !== dataModel.unpaidAmount">
                总价¥ <span>{{dataModel.amount|getMoney|getMoney1}}</span><span class="font-11">{{dataModel.amount|getMoney|getMoney2}}</span>，

              </span>
      <span class="color-55 font-14 line-14">
                应付
              </span>
      <span class="color-55 font-11 mr-1p">¥</span>
      <span>{{dataModel.unpaidAmount|getMoney|getMoney1}}</span><span
      class="font-11">{{dataModel.unpaidAmount|getMoney|getMoney2}}</span>
    </van-col>

    <!-- 其它情况 已支付，已关闭，已退款-->
    <!-- 显示已退款：refundAmount （红色   >0 才显示）   总价：订单总价（amount） 实付：totalAmount  amount=totalAmount的时候总价去掉即可-->
    <van-col class="text-primary font-14 line-14" v-else>
              <span class="color-red font-11 line-11" v-if="dataModel.refundAmount >0">
                已退款¥<span>{{dataModel.amount|getMoney|getMoney1}}</span><span
                class="font-11">{{dataModel.amount|getMoney|getMoney2}}</span>，
              </span>

      <div class="d-inline-block color-88 font-11 mr-1p">总价¥
        <span>{{dataModel.amount|getMoney|getMoney1}}</span><span
          class="font-11">{{dataModel.amount|getMoney|getMoney2}}</span>
      </div>
    </van-col>

  </div>
</template>

<script>
  export default {
    name: "orderJiaHuiFu",
    props: [
      'status',
      'dataModel',
      'expect',
      'expectMoney'
    ],
    mounted() {
    },
    methods: {}
  }
</script>

<style scoped>

</style>
